import Hammer from 'hammerjs'

export default {
    data() {
        return {
            transform: {
                scale: 1,
                translate: { x: 0, y: 0, startX: 0, startY: 0 },
                center: null
            },
            MAX_SCALE: 3,
            initScale: 1
        }
    },
    methods: {
        bindEvent() {
            const mc = new Hammer.Manager(this.el)
            mc.add(new Hammer.Pan({ threshold: 0, pointers: 0 }))
            mc.add(new Hammer.Swipe()).recognizeWith(mc.get('pan'))
            mc.add(
                new Hammer.Pinch({ threshold: 0 }).recognizeWith(mc.get('pan'))
            )
            mc.add(new Hammer.Tap({ event: 'doubletap', taps: 2 }))
            mc.on('panstart panmove', this.onPan)
            mc.on('pinchstart pinchmove', this.onPinch)
            if (this.slideTo) {
                mc.on('swipe', this.onSwipe)
            }
            mc.on('doubletap', this.onDoulebleTap)
        },
        updatePdfElStyle() {
            const { scale, translate, center } = this.transform
            this.el.style.transform = `scale(${scale}) translate(${translate.x}px,${translate.y}px)`
            this.el.style.transformOrigin = center
                ? `${center.x}px ${center.y}px`
                : 'center'
        },
        onPan(e) {
            // if ( this.transform.scale == 1) return
            if (e.type === 'panstart') {
                const { x, y } = this.transform.translate
                ;[
                    this.transform.translate.startX,
                    this.transform.translate.startY
                ] = [x, y]
            }
            const { startX, startY } = this.transform.translate
            this.transform.translate.x = startX + e.deltaX
            this.transform.translate.y = startY + e.deltaY
            this.updatePdfElStyle()
        },
        getOrigin(center) {
            return {
                x: center.x - this.el.offsetLeft,
                y: center.y - this.el.offsetTop
            }
        },
        onPinch(e) {
            if (e.type === 'pinchstart') {
                this.initScale = this.transform.scale
                this.transform.center = this.getOrigin(e.center)
            }
            this.transform.scale = Math.max(
                1,
                Math.min(this.initScale * e.scale, this.MAX_SCALE)
            )
            if (this.transform.scale == 1) {
                this.ResetPdfStyle()
                return
            }
            this.updatePdfElStyle()
        },
        onSwipe(e) {
            if (this.transform.scale > 1) return
            const direction = e.offsetDirection
            if (direction == 2) {
                this.slideTo(1)
            } else if (direction == 4) {
                this.slideTo(-1)
            }
        },
        ResetPdfStyle() {
            this.transform = {
                scale: 1,
                translate: { x: 0, y: 0, startX: 0, startY: 0 }
            }
            this.updatePdfElStyle()
        },
        onDoulebleTap(e) {
            if (this.transform.scale == 1) {
                this.transform.center = this.getOrigin(e.center)
                this.transform.scale = 2
                this.updatePdfElStyle()
            } else {
                this.ResetPdfStyle()
            }
        }
    }
}
